import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { rechargeDailyPata } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "rechargeUsersClimbTowersLayers",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [// {
      //   label: "新增设备",
      //   id: "device_id"
      // },
      {
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user"
      },
      tableList: [],
      serverList: []
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (!this.paramsData.dimension_kind) {
        this.$message.error(this.$t('pleaseSelectNewDeviceOrAccount'));
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels
      };
      rechargeDailyPata(params).then(function (res) {
        if (res.code == 200) {
          (function () {
            var data = res.data;
            var level_map = res.level_map;
            var statusArr = [];
            var tableItem = []; //处理表格数据

            for (var m in level_map) {
              _this2.tableData.push({});

              tableItem.push({});
            }

            for (var i in data) {
              for (var j in data[i]) {
                statusArr.push(j);
              }

              break;
            }

            var _loop = function _loop(_i) {
              var dateItem = {
                label: _i,
                prop: _i,
                list: []
              };
              statusArr.forEach(function (item) {
                dateItem.list.push({
                  label: _this2.$t('personCount') + item,
                  prop: _i + item + "recharge_level_level_1"
                }, {
                  label: _this2.$t('avgTaskNum') + item,
                  prop: _i + item + "avg_task_num_level_1"
                });
              });

              _this2.tableList.push(dateItem);
            };

            for (var _i in data) {
              _loop(_i);
            }

            var _loop2 = function _loop2(_i2) {
              //数据处理
              _this2.tableData.forEach(function (item, index) {
                statusArr.forEach(function (items, idx) {
                  _this2.tableData[index][_i2 + "".concat(statusArr[idx], "avg_task_num_level_1")] = data[_i2][statusArr[idx]]["avg_task_num_level_" + (index + 1)].toFixed(2);
                  _this2.tableData[index][_i2 + "".concat(statusArr[idx], "recharge_level_level_1")] = data[_i2][statusArr[idx]]["recharge_level_level_" + (index + 1)];
                });
              });
            };

            for (var _i2 in data) {
              _loop2(_i2);
            }

            _this2.tableList.unshift({
              label: '',
              list: [{
                label: _this2.$t('payAmount'),
                prop: 'level_amount'
              }]
            });

            tableItem.forEach(function (items, idx) {
              _this2.tableData[idx]["level_amount"] = level_map["level_".concat(idx + 1)];
            });
          })();
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        item.list.forEach(function (items, indexs) {
          columns.push({
            label: indexs == 0 ? item.label : '',
            prop: items.prop
          });
          d[items.prop] = items.label;
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      data.unshift(d);
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};